<template>
  <div class="page-content">
    <breadcrumb-index :items="breadcrumbs">
      <template #actions>
        <router-link :to="`/app/exams/${examId}/subjects`" class="btn btn-outline-secondary btn-sm">
          <vue-feather type="arrow-left" size="14" class="me-1" />
          Back
        </router-link>
      </template>
    </breadcrumb-index>

    <div class="card">
      <div class="card-header">
        <h6 class="card-title mb-0">Add Subject</h6>
        <small class="text-muted" v-if="exam">for {{ exam.name }}</small>
      </div>
      <div class="card-body">
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-lg-8">
              <div class="row">
                <div class="col-md-8 mb-3">
                  <label class="form-label">Subject Name <span class="text-danger">*</span></label>
                  <input v-model="form.name" type="text" class="form-control" required placeholder="e.g., Indian History" />
                </div>
                <div class="col-md-4 mb-3">
                  <label class="form-label">Display Order</label>
                  <input v-model.number="form.order_index" type="number" class="form-control" min="0" />
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Description</label>
                <textarea v-model="form.description" class="form-control" rows="3" placeholder="Brief description of the subject"></textarea>
              </div>

              <div class="row">
                <div class="col-md-4 mb-3">
                  <label class="form-label">Active</label>
                  <select v-model="form.is_active" class="form-select">
                    <option :value="true">Active</option>
                    <option :value="false">Inactive</option>
                  </select>
                </div>
              </div>

              <div v-if="error" class="alert alert-danger">{{ error }}</div>

              <div class="d-flex gap-2 pt-2">
                <button type="submit" class="btn btn-primary" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-1"></span>
                  Create Subject
                </button>
                <router-link :to="`/app/exams/${examId}/subjects`" class="btn btn-outline-secondary">Cancel</router-link>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/services/api'
import { useAlert } from '@/plugins/sweetalert'

export default {
  name: 'AddSubject',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const alert = useAlert()
    const examId = route.params.examId

    const exam = ref(null)
    const form = ref({
      name: '',
      description: '',
      order_index: 1,
      is_active: true
    })
    const loading = ref(false)
    const error = ref('')

    const breadcrumbs = computed(() => [
      { title: 'Dashboard', url: '/app/dashboard' },
      { title: 'Exams', url: '/app/exams/list' },
      { title: exam.value?.name || 'Exam', url: `/app/exams/edit/${examId}` },
      { title: 'Subjects', url: `/app/exams/${examId}/subjects` },
      { title: 'Add Subject', active: true }
    ])

    const fetchExam = async () => {
      try {
        const response = await api.get(`/v1/admin/exams/${examId}`)
        exam.value = response.data.exam
      } catch (err) {
        console.error('Failed to fetch exam:', err)
      }
    }

    const handleSubmit = async () => {
      loading.value = true
      error.value = ''

      try {
        await api.post('/v1/admin/subjects', { ...form.value, exam_id: examId })
        alert.success('Success', 'Subject created successfully')
        router.push(`/app/exams/${examId}/subjects`)
      } catch (err) {
        error.value = err.response?.data?.message || 'Failed to create subject'
      } finally {
        loading.value = false
      }
    }

    onMounted(fetchExam)

    return { examId, exam, form, loading, error, breadcrumbs, handleSubmit }
  }
}
</script>
